// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","453":"8701dc61","455":"9eeb451c","977":"6a7f6471"}[chunkId] + ".chunk.js";
};